import { type FC } from 'react';

import { MortgageCalculator } from './MortgageCalculator';

export const MortgageCalculatorContainer: FC = () => <MortgageCalculator />;
